import type { PerguntaConselho, RespostasConselho } from '@ponti/shared';

const INP = 'w-full rounded-md border-2 border-slate-200 px-3 py-2 text-sm outline-none focus:border-institutional';

/** Renderiza as perguntas configuradas de uma vaga e coleta as respostas. */
export function FormularioPerguntas({ perguntas, valores, onChange }: {
  perguntas: PerguntaConselho[];
  valores: RespostasConselho;
  onChange: (next: RespostasConselho) => void;
}) {
  function setVal(id: string, v: string | string[]) {
    onChange({ ...valores, [id]: v });
  }
  function toggleMultipla(id: string, opcao: string) {
    const atual = Array.isArray(valores[id]) ? (valores[id] as string[]) : [];
    setVal(id, atual.includes(opcao) ? atual.filter((o) => o !== opcao) : [...atual, opcao]);
  }

  return (
    <div className="space-y-3">
      {perguntas.map((p) => (
        <div key={p.id}>
          <label className="mb-1 block text-sm font-medium text-slate-700">
            {p.label} {p.obrigatoria && <span className="text-red-500">*</span>}
          </label>
          {p.tipo === 'texto' && (
            <input value={(valores[p.id] as string) ?? ''} onChange={(e) => setVal(p.id, e.target.value)} className={INP} />
          )}
          {p.tipo === 'texto_longo' && (
            <textarea value={(valores[p.id] as string) ?? ''} onChange={(e) => setVal(p.id, e.target.value)} rows={3} className={INP} />
          )}
          {p.tipo === 'sim_nao' && (
            <div className="flex gap-4 text-sm text-slate-700">
              {['Sim', 'Não'].map((o) => (
                <label key={o} className="flex items-center gap-1.5">
                  <input type="radio" name={p.id} checked={valores[p.id] === o} onChange={() => setVal(p.id, o)} /> {o}
                </label>
              ))}
            </div>
          )}
          {p.tipo === 'escolha_unica' && (
            <div className="space-y-1 text-sm text-slate-700">
              {(p.opcoes ?? []).map((o) => (
                <label key={o} className="flex items-center gap-1.5">
                  <input type="radio" name={p.id} checked={valores[p.id] === o} onChange={() => setVal(p.id, o)} /> {o}
                </label>
              ))}
            </div>
          )}
          {p.tipo === 'multipla' && (
            <div className="space-y-1 text-sm text-slate-700">
              {(p.opcoes ?? []).map((o) => (
                <label key={o} className="flex items-center gap-1.5">
                  <input type="checkbox" checked={Array.isArray(valores[p.id]) && (valores[p.id] as string[]).includes(o)} onChange={() => toggleMultipla(p.id, o)} /> {o}
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/** Valida obrigatórias; devolve o id da primeira pergunta não respondida, ou null. */
export function primeiraPendente(perguntas: PerguntaConselho[], valores: RespostasConselho): PerguntaConselho | null {
  for (const p of perguntas) {
    if (!p.obrigatoria) continue;
    const v = valores[p.id];
    const vazio = v === undefined || v === '' || (Array.isArray(v) && v.length === 0);
    if (vazio) return p;
  }
  return null;
}
